import React, { useContext } from 'react'
import { Hydrator } from '@usap/core'
import { LocalContext } from '../../../../helpers/useLocalContext'
import RelatedCategories from './RelatedCategories.loadable'

const RelatedCategoriesLazyLoader = props => {
  const { localContext } = useContext(LocalContext)
  const { isBot } = localContext

  return (
    <Hydrator
      Component={RelatedCategories}
      lazy={!isBot}
      {...props}
    />
  )
}

export default RelatedCategoriesLazyLoader
